// TODO: Delete unused action types
export const LOADING_SHOW = 'LOADING_SHOW';
export const LOADING_HIDE = 'LOADING_HIDE';
export const LOADING_PAGE = 'LOADING_PAGE';
export const LOADED_PAGE = 'LOADED_PAGE';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';
export const SMS_REQUEST = 'SMS_REQUEST';
export const BRANDS_FETCH = 'BRANDS_FETCH';
export const BRANDS_ADD = 'BRANDS_ADD';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const RESPONSE_SHOW = 'RESPONSE_SHOW';
export const TRACK_PAGE_VIEW = 'TRACK_PAGE_VIEW';
export const BANK_REDIRECT_URL_SAVE = 'BANK_REDIRECT_URL_SAVE';
export const INITIALIZE_GA = 'INITIALIZE_GA';
export const OFFERS_SAVE = 'OFFERS_SAVE';
export const OFFERS_FETCH = 'OFFERS_FETCH';
export const SAVE_CURRENT_CARD_BRAND = 'SAVE_CURRENT_CARD_BRAND';
export const CREATE_SESSION = 'CREATE_SESSION';
export const FETCH_CLIENT = 'FETCH_CLIENT';
export const SAVE_SESSION = 'SAVE_SESSION';
export const SAVE_CLIENT_MSISDN = 'SAVE_CLIENT_MSISDN';
export const SAVE_SESSION_ID = 'SAVE_SESSION_ID';
export const SAVE_CLIENT_INFO = 'SAVE_CLIENT_INFO';
export const SAVE_CLIENT_TYPE = 'SAVE_CLIENT_TYPE';
export const SAVE_CARD = 'SAVE_CARD';
export const SAVE_PLANS = 'SAVE_PLANS';
export const PLAN_SELECT = 'PLAN_SELECT';
export const TOKEN_VERIFY = 'TOKEN_VERIFY';
export const TOKEN_ERROR = 'TOKEN_ERROR';
export const TOKEN_CORRECT = 'TOKEN_CORRECT';
export const REDIRECT_ROUTE = 'REDIRECT_URL';
export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_V2_REQUEST = 'SUBSCRIPTION_V2_REQUEST';
export const CHANGE_CARD_REQUEST = 'CHANGE_CARD_REQUEST';
export const SAVE_LAST_DIGITS = 'SAVE_LAST_DIGITS';
export const SAVE_VENDOR_INFO = 'SAVE_VENDOR_INFO';
export const LOGIN_VENDOR = 'LOGIN_VENDOR';
export const CLEAN_CARD = 'CLEAN_CARD';
export const SAVE_CPF = 'SAVE_CPF';
